// extracted by mini-css-extract-plugin
export var formContainer = "_e9-0";
export var message = "_e9-1";